module.exports = {
    parse: require('./lib/parse'),
    stringify: require('./lib/stringify')
};



//////////////////
// WEBPACK FOOTER
// ./~/html-parse-stringify2/index.js
// module id = 66
// module chunks = 35783957827783 162898551421021 251080691916612